import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { Toaster } from 'react-hot-toast';
import { AuthProvider, useAuth } from './context/AuthContext';

import Navbar from './components/common/Navbar';
import Footer from './components/common/Footer';

import Home from './pages/Home';
import Jobs from './pages/Jobs';
import JobDetail from './pages/JobDetail';
import Services from './pages/Services';
import ServiceDetail from './pages/ServiceDetail';
import Auth from './pages/Auth';
import Dashboard from './pages/Dashboard';
import PostJob from './pages/PostJob';
import PostService from './pages/PostService';
import Professionals from './pages/Professionals';
import Organizations from './pages/Organizations';
import About from './pages/About';
import Privacy from './pages/Privacy';
import Terms from './pages/Terms';
import Contact from './pages/Contact';
import ProfilePage from './pages/ProfilePage';
import ProfileEdit from './pages/ProfileEdit';
import Messages from './pages/Messages';
import Notifications from './pages/Notifications';
import JobApplications from './pages/JobApplications';
import JobApply from './pages/JobApply';

const ProtectedRoute = ({ children }) => {
  const { user, loading } = useAuth();
  if (loading) return <div className="page-loading"><div className="spinner"></div></div>;
  return user ? children : <Navigate to="/auth/login" replace />;
};

const GuestRoute = ({ children }) => {
  const { user, loading } = useAuth();
  if (loading) return <div className="page-loading"><div className="spinner"></div></div>;
  return !user ? children : <Navigate to="/dashboard" replace />;
};

function AppLayout() {
  return (
    <Router>
      <div className="app-wrapper">
        <Navbar />
        <main className="main-content">
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/jobs" element={<Jobs />} />
            <Route path="/jobs/:id" element={<JobDetail />} />
            <Route path="/services" element={<Services />} />
            <Route path="/services/:id" element={<ServiceDetail />} />
            <Route path="/professionals" element={<Professionals />} />
            <Route path="/organizations" element={<Organizations />} />
            <Route path="/about" element={<About />} />
            <Route path="/privacy" element={<Privacy />} />
            <Route path="/terms" element={<Terms />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/profile/:uuid" element={<ProfilePage />} />

            <Route path="/auth/login" element={<GuestRoute><Auth mode="login" /></GuestRoute>} />
            <Route path="/auth/register" element={<GuestRoute><Auth mode="register" /></GuestRoute>} />

            <Route path="/dashboard" element={<ProtectedRoute><Dashboard /></ProtectedRoute>} />
            <Route path="/post-job" element={<ProtectedRoute><PostJob /></ProtectedRoute>} />
            <Route path="/post-service" element={<ProtectedRoute><PostService /></ProtectedRoute>} />
            <Route path="/profile/edit" element={<ProtectedRoute><ProfileEdit /></ProtectedRoute>} />
            <Route path="/messages" element={<ProtectedRoute><Messages /></ProtectedRoute>} />
            <Route path="/messages/:uuid" element={<ProtectedRoute><Messages /></ProtectedRoute>} />
            <Route path="/notifications" element={<ProtectedRoute><Notifications /></ProtectedRoute>} />
            <Route path="/jobs/:id/apply" element={<ProtectedRoute><JobApply /></ProtectedRoute>} />
            <Route path="/jobs/:id/applications" element={<ProtectedRoute><JobApplications /></ProtectedRoute>} />

            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </main>
        <Footer />
      </div>
      <Toaster
        position="top-center"
        toastOptions={{
          style: {
            background: '#0D1421',
            color: '#E2E8F0',
            border: '1px solid rgba(0,212,255,0.3)',
            fontFamily: 'Cairo, sans-serif',
            direction: 'rtl',
          },
          success: { iconTheme: { primary: '#00D4FF', secondary: '#0D1421' } },
          error: { iconTheme: { primary: '#FF6B35', secondary: '#0D1421' } },
        }}
      />
    </Router>
  );
}

function App() {
  return (
    <AuthProvider>
      <AppLayout />
    </AuthProvider>
  );
}

export default App;
